import React from 'react'
import EventsTable from './components/EventsTable'
import SharedFilters from '../../../components/SharedFilters'
import useEventsList from './hooks/useEventsList'
import AppPagination from '../../../components/AppPagination'

export default function EventsListScreen() {
  const { state, actions } = useEventsList()

  return (
    <div className="mx-auto flex w-full max-w-[1460px] flex-col gap-6 pb-20">
      {/* ── Header ── */}
      <section className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <p className="text-xs font-black uppercase tracking-[0.16em] text-primary">
            Cloud &amp; Campus Engagement
          </p>
          <div className="flex items-center gap-3 mt-1">
            <h1 className="font-display text-3xl font-extrabold tracking-tight text-on-surface">
              List of Events
            </h1>
            <span className="rounded-xl bg-surface-container-high px-3 py-1 text-xs font-bold text-on-surface-variant">
              {state.totalCount} entries
            </span>
          </div>
        </div>
      </section>

      {/* ── Filter Accordion with Period ── */}
      <SharedFilters
        companyFilter={state.companyFilter}
        branchFilter={state.branchFilter}
        courseFilter={state.courseFilter}
        batchFilter={state.batchFilter}
        periodFilter={state.periodFilter}
        fromDate={state.fromDate}
        tillDate={state.tillDate}
        setCompanyFilter={actions.setCompanyFilter}
        setBranchFilter={actions.setBranchFilter}
        setCourseFilter={actions.setCourseFilter}
        setBatchFilter={actions.setBatchFilter}
        setPeriodFilter={actions.setPeriodFilter}
        setFromDate={actions.setFromDate}
        setTillDate={actions.setTillDate}
        onReset={actions.handleResetFilters}
        onSearch={actions.loadData}
        companyOptions={state.options.companies}
        branchOptions={state.options.branches}
        courseOptions={state.options.courses}
        batchOptions={state.options.batches}
        periodOptions={state.options.periods}
        visibleAccordionFilters={['company', 'branch', 'course', 'batch', 'period', 'fromDate', 'tillDate']}
      />

      {/* ── Events Table & Pagination Wrapper ── */}
      <div className="flex flex-col gap-4">
        <EventsTable
          records={state.pagedRecords}
          loading={state.loading}
          onDelete={actions.handleDelete}
        />

        {state.totalCount > 0 && (
          <div className="flex flex-col gap-3 rounded-2xl border border-outline-variant/25 bg-surface-container-lowest px-6 py-4 sm:flex-row sm:items-center sm:justify-between shadow-xs">
            <span className="text-xs font-medium text-on-surface-variant">
              Showing {state.rangeStart} to {state.rangeEnd} of {state.totalCount} entries
            </span>

            <AppPagination
              page={state.page}
              totalPages={state.totalPages}
              onPageChange={actions.setPage}
              onPrevious={actions.goToPreviousPage}
              onNext={actions.goToNextPage}
              canPrevious={state.page > 1}
              canNext={state.page < state.totalPages}
            />
          </div>
        )}
      </div>
    </div>
  )
}
